import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Language} from '../../../models/language';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-site-menu-footer',
    templateUrl: './site-menu-footer.component.html',
    styleUrls: ['./site-menu-footer.component.scss']
})
export class SiteMenuFooterComponent {

    @Input()
    isLoggedIn: boolean;
    @Output()
    closeSiteMenu = new EventEmitter();
    @Input()
    languages: Language[];
    @Input()
    currentLanguage: Language;
    @Output()
    languageSwitched = new EventEmitter<Language>();
    @Output()
    loggedOut = new EventEmitter();

    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer
    ) {
        this.matIconRegistry.addSvgIcon(
            'hering-language-german',
            this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/header/language-german.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'hering-language-english',
            this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/header/language-english.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'hering-account',
            this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/header/account.svg')
        );
    }

    switchLanguage(language: Language) {
        this.languageSwitched.emit(language);
    }

    logout() {
        this.onCloseSiteMenu();
        this.loggedOut.emit();
    }

    onCloseSiteMenu() {
        this.closeSiteMenu.emit();
    }
}
